import { Component, Input, OnInit } from '@angular/core';
import { RecruitPageConfigModel } from 'services/models/recruitment/recruitment-page-config.model';

@Component({
  selector: 'app-configurable-title',
  templateUrl: './configurable-title.component.html',
  styleUrls: ['./configurable-title.component.scss']
})
export class ConfigurableTitleComponent implements OnInit {
  
  @Input() config: RecruitPageConfigModel | null = null;
  @Input() fallbackTitle: string = 'Trabalhe Conosco';
  @Input() cssClass: string = 'hero-title';

  public displayTitle: string = '';

  ngOnInit(): void {
    this.updateDisplayTitle();
  }

  ngOnChanges(): void {
    this.updateDisplayTitle();
  }

  private updateDisplayTitle(): void {
    if (this.config?.title && this.config.title.trim()) {
      this.displayTitle = this.config.title;
    } else {
      this.displayTitle = this.fallbackTitle;
    }
  }
}
